import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap"; // Importing React Bootstrap components
import ProgressBar from "react-bootstrap/ProgressBar";

import Editbtn from "../images/circum_edit.svg";
import viewbtn from "../images/iconoir_eye-solid.svg";
import commentbtn from "../images/lets-icons_comment-light.svg";
import stepbtn from "../pages/Skills/images/step_btn.svg";
import Select from "react-select";
import { isObject } from "formik";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../config";

const DataTable = () => {
  const navigate = useNavigate();
  const getFirstDayOfCurrentYear = () => `${new Date().getFullYear()}-01-01`;
  const role = localStorage.getItem("userrole");
  const deptid = localStorage.getItem("departmentid");
  const currentuserid = localStorage.getItem("employeeid");
  const searchString = "ROLE_";
  const shouldDefaultDateFilter = [
    "ROLE_HR",
    "ROLE_SENIOR HR MANAGER",
    "ROLE_MANAGER",
    "ROLE_SUPERVISOR",
  ].includes(role);
  const defaultStartDate = shouldDefaultDateFilter
    ? getFirstDayOfCurrentYear()
    : "";
  const [posts, setPosts] = useState({ smartgoals: [] });

  // const [editedSmartGoal, setEditedSmartGoal] = useState(null);
  const [selectedSmartGoal, setSelectedSmartGoal] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showViewModalsub, setShowViewModalsub] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [viewSmartGoal, setViewSmartGoal] = useState(null);
  const [viewSubGoal, setViewSubGoal] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [postsSub, setPostsSub] = useState({ subgoals: [] });
  const [editedSubGoal, setEditedSubGoal] = useState(null);
  const [options, setOptions] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [filterdepartment, setFilterdepartment] = useState("");
  const [filterenddate, setFilterenddate] = useState("");
  const [filterstartdate, setFilterStartdate] = useState(defaultStartDate);

  const [filterassignee, setFilterassignee] = useState("");
  const [showEditModalsub, setShowEditModalsub] = useState(false);
  const [showsmartgoalEdit, setshowSmartGoaledit] = useState(false);
  const [showsubgoalEdit, setShowSubgoalEdit] = useState(false);
  const managerId = localStorage.getItem("employeeid");
  const [employeesData, setEmployeesData] = useState([]);
  const [setFieldvalue, setFieldValue] = useState([]);
  const [touched, setTouched] = useState([]);
  const [errors, setErrors] = useState([]);
  const [values, setValues] = useState([]);
  const [allemployees, setAllEmployees] = useState([]);
  const [showdatefilter, setShowDatefilter] = useState(false);
  const [showdeptfilter, setShowDeptfilter] = useState(false);
  const [showassigneefilter, setShowAssigneefilter] = useState(false);
  const [assigneevalues, setAssigneevalues] = useState(null);
  const [selectedAssigneeOption, setSelectedAssigneeOption] = useState(null);
  const [selectedAssgneeForEdit, setSelectedAssgneeForEdit] = useState([]);

  // for pagination -start
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageGroupStart, setPageGroupStart] = useState(1);

  const pagesPerGroup = 10;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);

    setPageGroupStart(
      Math.floor((pageNumber - 1) / pagesPerGroup) * pagesPerGroup + 1
    );

    // fetchPostList(pageNumber);
    getAllSmartgoalsforConditions(
      filterdepartment,
      filterenddate,
      filterstartdate,
      filterassignee,
      pageNumber
    );
  };

  // Change page
  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate which pages to show
  const currentPageNumbers = Array.from(
    { length: Math.min(pagesPerGroup, totalPageCount - pageGroupStart + 1) },
    (_, i) => pageGroupStart + i
  );

  const handleNextGroup = () => {
    const nextGroupStart = pageGroupStart + pagesPerGroup;
    if (nextGroupStart <= totalPageCount) {
      setPageGroupStart(nextGroupStart);
      setCurrentPage(nextGroupStart);
      getAllSmartgoalsforConditions(
        filterdepartment,
        filterenddate,
        filterstartdate,
        filterassignee,
        nextGroupStart
      );
    }
  };

  const handlePrevGroup = () => {
    const prevGroupStart = pageGroupStart - pagesPerGroup;
    if (prevGroupStart > 0) {
      setPageGroupStart(prevGroupStart);
      setCurrentPage(prevGroupStart);
      getAllSmartgoalsforConditions(
        filterdepartment,
        filterenddate,
        filterstartdate,
        filterassignee,
        prevGroupStart
      );
    }
  };

  // for pagination - end

  let currentGoals = null;
  let rolename = "";
  if (role) {
    rolename = role.substring(role.indexOf(searchString) + searchString.length);
  } else {
    rolename = "guest";
  }

  const fetchPostList = async (
    pageNo = currentPage,
    startdate = defaultStartDate,
    enddate = ""
  ) => {
    try {
      let strAPI = "";
      let empid = localStorage.getItem("employeeid");
      const startDateQuery = startdate || "";
      const endDateQuery = enddate || "";

      if (role === "ROLE_HR" || role === "ROLE_SENIOR HR MANAGER") {
        // strAPI =
        //   `${baseURL}/api/get-all-smart-goals?did=0` +
        //   "&assignee=null&enddate=null&startdate=null";
        strAPI =
          `${baseURL}/api/get-all-smart-goals?did=0` +
          `&assignee=&enddate=${endDateQuery}&startdate=${startDateQuery}&page=${pageNo}`;
        setFilterdepartment(0);
        console.log("second");

        setshowSmartGoaledit(true);
        setShowSubgoalEdit(true);
        setShowDatefilter(true);
        setShowDeptfilter(true);
        setShowAssigneefilter(true);
      } else if (role === "ROLE_MANAGER" && currentuserid === "8367") {
        strAPI =
          // `${baseURL}/api/get-all-smart-goals?did=` +
          // deptid +
          `${baseURL}/api/get-all-smart-goals?` +
          // "&mgrid=" +
          "mgrid=" +
          currentuserid +
          "&spMgr=true" +
          "&startdate=" +
          startDateQuery +
          "&enddate=" +
          endDateQuery +
          "&page=" +
          pageNo;
        setFilterdepartment(0);
        console.log("third");

        setshowSmartGoaledit(true);
        setShowSubgoalEdit(true);
        setShowDatefilter(true);
        setShowDeptfilter(true);
        setShowAssigneefilter(true);
      } else if (role === "ROLE_MANAGER") {
        console.log("fourth");
        strAPI =
          `${baseURL}/api/get-all-smart-goals?did=` +
          deptid +
          "&mgrid=" +
          // `${baseURL}/api/get-all-smart-goals?` +
          // "mgrid=" +
          currentuserid +
          "&startdate=" +
          startDateQuery +
          "&enddate=" +
          endDateQuery +
          "&page=" +
          pageNo;

        setshowSmartGoaledit(true);
        setShowSubgoalEdit(true);
        setShowDatefilter(true);
        setShowDeptfilter(empid === "8367");
        setShowAssigneefilter(true);
      } else if (role === "ROLE_SUPERVISOR") {
        console.log("fifth");
        strAPI =
          // `${baseURL}/api/get-all-smart-goals?did=` +
          // deptid +
          // "&supervisor_id=" +
          `${baseURL}/api/get-all-smart-goals?` +
          "supervisor_id=" +
          currentuserid +
          "&startdate=" +
          startDateQuery +
          "&enddate=" +
          endDateQuery +
          "&page=" +
          pageNo;

        setshowSmartGoaledit(true);
        setShowSubgoalEdit(true);
        setShowDatefilter(true);
        setShowDeptfilter(empid === "8367");
        setShowAssigneefilter(true);
      } else {
        // Default case for employee (ROLE_USER or any other role not handled above)
        strAPI =
          `${baseURL}/api/get-all-smart-goals?did=` +
          deptid +
          "&assignee=" +
          currentuserid +
          "&startdate=" +
          startDateQuery +
          "&enddate=" +
          endDateQuery +
          "&page=" +
          pageNo;
        console.log("first");

        setFilterdepartment(deptid);
        setFilterassignee(currentuserid);

        setshowSmartGoaledit(false);
        setShowSubgoalEdit(false);
        setShowDatefilter(false);
        setShowDeptfilter(false);
        setShowAssigneefilter(false);
      }

      // const { data } = await axios(strAPI);
      // setPosts({ smartgoals: data.smartgoals });

      // api response like response.data
      const { data } = await axios(strAPI);
      setPosts({ smartgoals: data.data.data });
      setTotalPageCount(data.data.pagination.totalPages);
      setCurrentPage(data.data.pagination.page);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };
  const handleCloseCommentModal = () => {
    setShowCommentModal(false);
  };
  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };
  const handleCloseViewModalsub = () => {
    setShowViewModalsub(false);
  };
  const handleCloseEditModalsub1 = () => {
    setShowEditModalsub(false);
  };

  // Define handleSaveEditedSmartGoal function
  const handleSaveEditedSmartGoal = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/updatesmartgoal?id=${editedSmartGoal.id}`,
        editedSmartGoal
      );
      console.log("Updated SmartGoals:", response.data);
      // Update the state with the updated grade
      const updatedSmartgoals = posts.smartgoals.map((smartgoal) => {
        if (smartgoal.id === editedSmartGoal.id) {
          return editedSmartGoal;
        }
        return smartgoal;
      });
      setPosts({ smartgoals: updatedSmartgoals });
      setShowEditModal(false);
      navigate("/goals");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Grade not found. Please try again.");
      } else {
        console.error("Error updating Grade:", error);
      }
    }
  };

  // Define the getProgressColor function
  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  const [editedSmartGoal, setEditedSmartGoal] = useState({
    assignees: [], // Ensure this is initialized as an array
    assigneeids: [10, 20, 20, 2],
  });
  const [editedSmartSubGoal, setEditedSmartSubGoal] = useState({
    assignees: [], // Ensure this is initialized as an array
    assigneeids: [10, 20, 20, 2],
  });

  console.log(editedSmartGoal);

  // Toggle expand row
  const toggleExpand = (index, smartid) => {
    getSubgoals(smartid);
    setExpandedRow(expandedRow === index ? null : index);
  };

  const handleChangeAssignee = (selectedOption) => {
    setFilterassignee(selectedOption);
    // Additional logic if needed
  };

  const optionsassignee = teamMembers.map((member) => ({
    value: member.employeeid,
    label: `${member.FirstName} ${member.LastName} - ${member.employeeid}`,
  }));

  const getSubgoals = async (smartid, arrTeamdata) => {
    try {
      const { data } = await axios(`${baseURL}/getsubgoals?smartid=` + smartid);
      if (Array.isArray(data.subgoals)) {
        setPostsSub({ subgoals: data.subgoals });
      } else {
        //  console.error("Data is not an array:", data);
      }
      // setTeamMembers(arrTeamdata);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleView = (smartgoal) => {
    setViewSmartGoal(smartgoal); // Set the viewSmartGoal state
    setShowViewModal(true);
  };
  const handleEdit = (smartgoal) => {
    setEditedSmartGoal(smartgoal);
    setShowEditModal(true);
  };
  const handleViewsub = (subgoal) => {
    setViewSubGoal(subgoal); // Set the viewSmartGoal state
    setShowViewModalsub(true);
  };
  const handleEditsub = (currsubgoal) => {
    //    setEditedSubGoal(currsubgoal);
    console.log(currsubgoal, "gggggggggggg");
    setEditedSmartSubGoal(currsubgoal);
    console.log("CURRENT EDITING SUBGOAL===");
    console.log(currsubgoal);
    console.log("CURRENT EDITING SUBGOAL===");
    setShowEditModalsub(true);
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    // Ensure assigneeids is stored as a comma-separated string
    setEditedSmartGoal({
      ...editedSmartGoal,
      assigneeids: selectedValues.join(","),
    });
  };
  const handleSubgoalChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    // Ensure assigneeids is stored as a comma-separated string
    setEditedSmartSubGoal({
      ...editedSmartSubGoal,
      assigneeids: selectedValues.join(","),
    });
    console.log("==inside handleSubgoalChange ===");
    console.log({
      ...editedSmartSubGoal,
      assigneeids: selectedValues.join(","),
    });
  };

  // Determine if assigneeids is an array or a comma-separated string
  const assigneeIdsArray =
    Array.isArray(editedSmartGoal.assigneeids) && editedSmartGoal
      ? editedSmartGoal.assigneeids
      : editedSmartGoal.assigneeids
          .split(",")
          .map((id) => parseInt(id.trim(), 10));

  const selectedEmployees = employeesData
    .filter((employee) => assigneeIdsArray.includes(employee.employeeid))
    .map((employee) => ({
      value: employee.employeeid,
      label: `${employee.FirstName} ${employee.LastName}`,
    }));

  const assigneeIdsArraysub =
    Array.isArray(editedSmartSubGoal.assigneeids) && editedSmartSubGoal
      ? editedSmartSubGoal.assigneeids
      : editedSmartSubGoal.assigneeids
          .split(",")
          .map((id) => parseInt(id.trim(), 10));

  const selectedSubgoalEmployees = employeesData
    .filter((employee) => assigneeIdsArraysub.includes(employee.id))
    .map((employee) => ({
      value: employee.id,
      label: `${employee.FirstName} ${employee.LastName}`,
    }));

  const handleSaveEditedSubGoal = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/updatesubgoal?id=${editedSmartSubGoal.id}`,
        editedSmartSubGoal
      );
      console.log("Updated SubGoal:======", response.data);
      // Update the state with the updated subgoal
      const updatedSubgoals = postsSub.subgoals.map((subgoal) => {
        if (subgoal.id === editedSmartSubGoal.id) {
          return editedSmartSubGoal;
        }
        return subgoal;
      });
      setPostsSub({ subgoals: updatedSubgoals });
      setShowEditModalsub(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("SubGoal not found. Please try again.");
      } else {
        console.error("Error updating SubGoal:", error);
      }
    }
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPostsSub = postsSub.subgoals.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  currentGoals = posts.smartgoals.slice(indexOfFirstPost, indexOfLastPost);

  const [value, setValue] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (role === "ROLE_MANAGER" && currentuserid === "8367") {
          const response = await axios.get(`${baseURL}/getDepartmentsForMgr`);
          setOptions(response.data.departments);
        } else {
          const response = await axios.get(`${baseURL}/getdepartments`);
          setOptions(response.data.departments);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
    fetchPostList();
  }, []);

  const getAllSmartgoalsforConditions = async (
    did,
    enddate,
    startdate,
    assignee,
    pageNo = currentPage
  ) => {
    try {
      if (isObject(enddate)) enddate = "";
      if (isObject(startdate)) startdate = "";
      if (isObject(assignee)) assignee = "";
      if (isObject(did)) did = "";
      let api =
        `${baseURL}/api/get-all-smart-goals?did=` +
        did +
        "&assignee=" +
        assignee +
        "&enddate=" +
        enddate +
        "&startdate=" +
        startdate +
        "&page=" +
        pageNo;

      if (
        role === "ROLE_MANAGER" ||
        currentuserid === "8367" ||
        role === "ROLE_SUPERVISOR"
      ) {
        if (did === "") {
          did = localStorage.getItem("departmentid");
        }
        api =
          `${baseURL}/api/get-all-smart-goals?did=` +
          did +
          "&assignee=" +
          // `${baseURL}/api/get-all-smart-goals?` +
          // "assignee=" +
          assignee +
          "&enddate=" +
          enddate +
          "&startdate=" +
          startdate +
          "&page=" +
          pageNo +
          "&mgrid=" +
          currentuserid;
        if (role === "ROLE_SUPERVISOR") {
          api =
            // `${baseURL}/api/get-all-smart-goals?did=` +
            // deptid +
            // "&supervisor_id=" +
            `${baseURL}/api/get-all-smart-goals?` +
            "supervisor_id=" +
            currentuserid +
            "&assignee=" +
            assignee +
            "&startdate=" +
            startdate +
            "&enddate=" +
            enddate +
            "&page=" +
            pageNo;
        }
      }

      if (
        role === "ROLE_HR" ||
        role === "ROLE_SENIOR HR MANAGER" ||
        currentuserid === "8367"
      ) {
        if (assignee)
          api =
            `${baseURL}/api/get-all-smart-goals?did=` +
            did +
            "&mgrid=" +
            currentuserid +
            "&assignee=" +
            assignee +
            "&enddate=" +
            enddate +
            "&startdate=" +
            startdate +
            "&page=" +
            pageNo;
      }
      const { data } = await axios(api);
      //if (Array.isArray(data.smartgoals)) {
      setPosts([]);
      // let sm = JSON.parse(data.smartgoals);
      //alert(sm);
      setFilterassignee(assignee);
      setPosts({ smartgoals: data.data.data });
      setTotalPageCount(data.data.pagination.totalPages);
      setCurrentPage(data.data.pagination.page);
      // currentGoals = data.smartgoals.slice(indexOfFirstPost, indexOfLastPost);
      //} else {
      // console.error("Data is not an array:", data);
      //  }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  // const handleSelectChangeForAssignee = (selectedOptions) => {
  //   // Update the selectedAssgneeForEdit state
  //   setSelectedAssgneeForEdit(selectedOptions);

  //   // Extract assignee IDs and names from the selected options
  //   const assigneeids = selectedOptions.map((option) => option.value).join(",");
  //   const assignees = selectedOptions.map((option) => option.label).join(", ");

  //   // Update the editedSmartGoal object
  //   setEditedSmartGoal({
  //     ...editedSmartGoal,
  //     assigneeids,
  //     assignees,
  //   });
  // };

  // const handleSelectChangeForAssignee = (selectedOptions) => {
  //   console.log("=== DEBUG SELECT CHANGE ===");
  //   console.log("selectedOptions received:", selectedOptions);

  //   // Ensure selectedOptions is always an array
  //   const options = selectedOptions || [];

  //   // Update the selectedAssgneeForEdit state
  //   setSelectedAssgneeForEdit(options);

  //   // Extract IDs and names
  //   const assigneeids = options.map((option) => option.value).join(",");
  //   const assignees = options.map((option) => option.label).join(", ");

  //   console.log("New assigneeids will be:", assigneeids);
  //   console.log("New assignees will be:", assignees);

  //   // Update the editedSmartGoal object
  //   // setEditedSmartGoal((prevState) => ({
  //   //   ...prevState,
  //   //   assigneeids,
  //   //   assignees,
  //   // }));

  //   setEditedSmartGoal((prevState) => ({
  //     ...prevState,
  //     assigneeids,
  //     assignees,
  //   }));

  //   console.log("=== END DEBUG ===");
  // };

  const extractIdFromLabel = (label) => {
    const match = label.match(/-\s*(\d+)\s*$/);
    return match ? match[1] : "";
  };

  const handleSelectChangeForAssignee = (selectedOptions) => {
    console.log("=== DEBUG SELECT CHANGE ===");
    console.log("selectedOptions received:", selectedOptions);

    const options = Array.isArray(selectedOptions) ? selectedOptions : [];

    setSelectedAssgneeForEdit(options);

    // Always pull the ID from the label
    const assigneeids = options
      .map((o) => extractIdFromLabel(o.label))
      .join(",");
    const assignees = options.map((o) => o.label).join(", ");

    console.log("New assigneeids will be:", assigneeids);
    console.log("New assignees will be:", assignees);

    setEditedSmartGoal((prev) => ({
      ...prev,
      assigneeids,
      assignees,
    }));

    console.log("=== END DEBUG ===");
  };

  useEffect(() => {
    if (editedSmartGoal.id) {
      const assigneesArray = editedSmartGoal.assignees.split(", ");
      const assigneeidsArray = editedSmartGoal.assigneeids.split(",");
      const selectedAssignees = assigneesArray.map((assignee, index) => ({
        value: assigneeidsArray[index],
        label: assignee,
      }));
      setSelectedAssgneeForEdit(selectedAssignees);
    }
  }, [editedSmartGoal]);

  // Improved useEffect for initializing selected assignees
  // useEffect(() => {
  //   console.log("=== INITIALIZING ASSIGNEES ===");
  //   console.log("editedSmartGoal:", editedSmartGoal);
  //   console.log("employeesData:", employeesData);

  //   if (
  //     editedSmartGoal &&
  //     editedSmartGoal.id &&
  //     employeesData &&
  //     employeesData.length > 0
  //   ) {
  //     try {
  //       let assigneeidsArray = [];
  //       let assigneesArray = [];

  //       // Handle assigneeids (could be string or array)
  //       if (editedSmartGoal.assigneeids) {
  //         if (typeof editedSmartGoal.assigneeids === "string") {
  //           assigneeidsArray = editedSmartGoal.assigneeids
  //             .split(",")
  //             .map((id) => id.trim());
  //         } else if (Array.isArray(editedSmartGoal.assigneeids)) {
  //           assigneeidsArray = editedSmartGoal.assigneeids.map((id) =>
  //             id.toString().trim()
  //           );
  //         }
  //       }

  //       // Handle assignees (could be string or array)
  //       if (editedSmartGoal.assignees) {
  //         if (typeof editedSmartGoal.assignees === "string") {
  //           assigneesArray = editedSmartGoal.assignees
  //             .split(", ")
  //             .map((name) => name.trim());
  //         } else if (Array.isArray(editedSmartGoal.assignees)) {
  //           assigneesArray = editedSmartGoal.assignees.map((name) =>
  //             name.toString().trim()
  //           );
  //         }
  //       }

  //       console.log("Processed assigneeidsArray:", assigneeidsArray);
  //       console.log("Processed assigneesArray:", assigneesArray);

  //       // Create selectedAssignees based on the data
  //       const selectedAssignees = [];

  //       // Method 1: If we have both IDs and names in the same order
  //       if (
  //         assigneeidsArray.length === assigneesArray.length &&
  //         assigneesArray.length > 0
  //       ) {
  //         for (let i = 0; i < assigneeidsArray.length; i++) {
  //           selectedAssignees.push({
  //             value: assigneeidsArray[i],
  //             label: assigneesArray[i],
  //           });
  //         }
  //       }
  //       // Method 2: Match IDs with employeesData to get correct labels
  //       else if (assigneeidsArray.length > 0) {
  //         assigneeidsArray.forEach((id) => {
  //           const employee = employeesData.find(
  //             (emp) =>
  //               emp.employeeid?.toString() === id.toString() ||
  //               emp.id?.toString() === id.toString()
  //           );

  //           if (employee) {
  //             selectedAssignees.push({
  //               value: id,
  //               label: `${employee.FirstName} ${employee.LastName} - ${
  //                 employee.employeeid || employee.id
  //               }`,
  //             });
  //           } else {
  //             console.warn("Employee not found for ID:", id);
  //           }
  //         });
  //       }

  //       console.log("Final selectedAssignees:", selectedAssignees);
  //       setSelectedAssgneeForEdit(selectedAssignees);
  //     } catch (error) {
  //       console.error("Error processing assignees:", error);
  //       setSelectedAssgneeForEdit([]);
  //     }
  //   } else {
  //     console.log("Clearing selectedAssgneeForEdit - no valid data");
  //     setSelectedAssgneeForEdit([]);
  //   }
  // }, [
  //   editedSmartGoal
  // ]);

  // Alternative simpler approach if you want to rebuild from employeesDat

  const fetchData = async () => {
    let response = null;
    let data = null;
    try {
      if (
        role === "ROLE_MANAGER" ||
        role === "ROLE_SUPERVISOR" ||
        currentuserid === "8367"
      ) {
        response = await axios.get(`${baseURL}/getteamlist?id=` + managerId);
        data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);

        setAllEmployees(response.data.team);
        setEmployeesData(response.data.team);
        setAssigneevalues(
          employeesData.map((employee) => employee.id).join(",")
        );
        console.log(data);
      }
      if (
        role === "ROLE_HR" ||
        role === "ROLE_SENIOR HR MANAGER" ||
        currentuserid === "8367"
      ) {
        response = await axios.get(`${baseURL}/getallassigneesb`);
        data = response.data;
        let arrTeamdata = data.employees;
        setTeamMembers(arrTeamdata);
        setFilterassignee(arrTeamdata);

        setAllEmployees(response.data.employees);
        setEmployeesData(response.data.employees);
        setAssigneevalues(
          employeesData.map((employee) => employee.id).join(",")
        );
        console.log(data);
      }
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  useEffect(() => {
    //   alert(managerId);
    // if (managerId) {managerId
    fetchData();
    //}
  }, [managerId]);

  const handleChangeDepartment = (event) => {
    let did = event.target.value;

    setFilterdepartment(did);

    fetchAssignees(did);

    getAllSmartgoalsforConditions(
      did,
      filterenddate,
      filterstartdate,
      filterassignee,
      1
    );
  };

  const fetchAssignees = async (did) => {
    try {
      const response = await axios.get(
        `${baseURL}/getallassigneesb?did=${did}`
      );

      setFilterassignee(response.data.employees);
      setTeamMembers(response.data.employees);
      setAllEmployees(response.data.employees);
      setEmployeesData(response.data.employees);
      setAssigneevalues(employeesData.map((employee) => employee.id).join(","));
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  useEffect(() => {
    // fetchAssignees();
  }, []);

  const handleChangdStartDate = (event) => {
    let startdate = event.target.value;
    setFilterStartdate(startdate);

    getAllSmartgoalsforConditions(
      filterdepartment,
      filterenddate,
      startdate,
      filterassignee,
      1
    );
  };

  const handleChangdDate = (event) => {
    let enddate = event.target.value;
    setFilterenddate(enddate);

    getAllSmartgoalsforConditions(
      filterdepartment,
      enddate,
      filterstartdate,
      filterassignee,
      1
    );
  };
  const handleChangdAssignee = (selval) => {
    //alert(selval);

    setFilterassignee(selval);

    // alert(selval);
    getAllSmartgoalsforConditions(
      filterdepartment,
      filterenddate,
      filterstartdate,
      selval,
      1
    );
  };

  const handleResetFilter = () => {
    const resetStartDate = defaultStartDate;
    setFilterdepartment("");
    setFilterenddate("");
    setFilterStartdate(resetStartDate);
    setFilterassignee("");
    setSelectedAssigneeOption(null);
    setCurrentPage(1);
    setPageGroupStart(1);
    fetchPostList(1, resetStartDate, "");
    fetchData();
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      fontSize: "13px",
      minHeight: "30px", // Adjust this value to set the desired height
      height: "30px",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "13px",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "13px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "13px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  return (
    <div>
      <div className="col-lg-12 d-flex flex-wrap p-2 pb-2">
        {showdatefilter && (
          <div className="w-10">
            {" "}
            <table>
              <tr>
                <td>From:</td>
                <td>
                  <div className="col-10">
                    <input
                      type="date"
                      name="startdate"
                      value={filterstartdate}
                      className="w-100 p-1 ml-1 border-light "
                      onChange={(e) => {
                        handleChangdStartDate(e);
                      }}
                    ></input>
                  </div>{" "}
                </td>
                <td>To:</td>
                <td>
                  <div className="col-lg-10">
                    <input
                      type="date"
                      name="enddate"
                      value={filterenddate}
                      className="w-100 p-1 ml-1 border-light "
                      onChange={(e) => {
                        handleChangdDate(e);
                      }}
                    ></input>
                  </div>{" "}
                </td>
              </tr>
            </table>
          </div>
        )}
        {showdeptfilter && (
          <div className="col-lg-2 d-flex">
            <select
              className="form-select w-100 form-control"
              name="departmentid"
              value={filterdepartment}
              onChange={(e) => {
                handleChangeDepartment(e);
              }}
            >
              <option value={"S"}> Select a department</option>
              {options.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.departmentname}
                </option>
              ))}
            </select>
          </div>
        )}

        {showassigneefilter && (
          <div className="col-lg-3 d-flex">
            <Select
              className="w-100 ml-1 p-0"
              value={filterassignee}
              styles={customStyles}
              onChange={(selOption) => {
                const selval = selOption.value;
                setSelectedAssigneeOption(selOption);
                console.log("===" + selOption);
                handleChangdAssignee(selval);
              }}
              options={optionsassignee}
              placeholder={
                selectedAssigneeOption
                  ? selectedAssigneeOption.label
                  : "Select Assignee"
              }
            />
          </div>
        )}

        <input
          className="bg-danger btn btn-sm text-white pl-3 pr-3 border-0 rounded "
          type="reset"
          value="Reset Filter"
          onClick={() => handleResetFilter()}
        />
      </div>

      {/* Your DataTable rendering logic */}
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>KPI</th>
            <th nowrap>Start Date</th>
            <th>End Date</th>
            <th>Department</th>
            <th>Assignees</th>
            <th>Progress</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {posts.smartgoals.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                No data
              </td>
            </tr>
          ) : (
            ""
          )}
          {posts.smartgoals.map((smartgoal, index) => (
            <React.Fragment key={index}>
              <tr>
                <td>{(currentPage - 1) * 10 + index + 1}</td>
                {/* <td>{ index + 1}</td> */}
                <td width="15%">{smartgoal.title}</td>
                <td width="9%">{formatDate(smartgoal.startdate)}</td>
                <td width="9%">{formatDate(smartgoal.enddate)}</td>
                <td>{smartgoal.departmentname}</td>
                {/* <td>{smartgoal.department.departmentname}</td> */}
                <td>{smartgoal.assignees}</td>
                <td hidden>{smartgoal.assigneeids}</td>
                <td>
                  <ProgressBar
                    variant={getProgressColor(smartgoal.progress)}
                    now={smartgoal.progress}
                  />
                </td>
                {/* Action buttons */}
                {/* <td style={{ whiteSpace: "nowrap" }}>
                  <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className="bg-transparent border-0  "
                    onClick={() => handleView(smartgoal)}
                  >
                    <img src={viewbtn} alt="'img" width="20"></img>
                  </ReactBootstrap.Button>
                  <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className="bg-transparent border-0  "
                    onClick={() => showsmartgoalEdit && handleEdit(smartgoal)}
                  >
                    <img src={Editbtn} alt="'img" width="20"></img>
                  </ReactBootstrap.Button>

                  <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className=" bg-transparent border-0 "
                    onClick={() => toggleExpand(index, smartgoal.id)}
                  >
                    <img src={stepbtn} alt="'img"></img>
                  </ReactBootstrap.Button>
                </td> */}


                {/* Action buttons - Hide edit icon for own KPIs */}
                <td style={{ whiteSpace: "nowrap" }}>
                  <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className="bg-transparent border-0"
                    onClick={() => handleView(smartgoal)}
                  >
                    <img src={viewbtn} alt="view" width="20"></img>
                  </ReactBootstrap.Button>

                  {showsmartgoalEdit && !smartgoal.isOwnKpi && (
                    <ReactBootstrap.Button
                      style={{ cursor: "pointer" }}
                      className="bg-transparent border-0"
                      onClick={() => handleEdit(smartgoal)}
                    >
                      <img src={Editbtn} alt="edit" width="20"></img>
                    </ReactBootstrap.Button>
                  )}

                  {/* <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className="bg-transparent border-0  "
                    onClick={() => showsmartgoalEdit && !smartgoal.isOwnKpi && handleEdit(smartgoal)}
                  >
                    <img src={Editbtn} alt="'img" width="20"></img>
                  </ReactBootstrap.Button> */}

                  <ReactBootstrap.Button
                    style={{ cursor: "pointer" }}
                    className="bg-transparent border-0"
                    onClick={() => toggleExpand(index, smartgoal.id)}
                  >
                    <img src={stepbtn} alt="expand"></img>
                  </ReactBootstrap.Button>
                </td>
              </tr>

              {expandedRow === index && (
                <tr>
                  <td colSpan="12" className="p-1 pb-3">
                    {/* New table with 5 columns */}
                    <h5 className="mt-2 mb-2 float-start">Sub KPI List</h5>
                    {showsubgoalEdit && (
                      <a
                        href={`/subgoal?id=${smartgoal.id}&did=${smartgoal.departmentid}`}
                      >
                        <button className="savebtn float-end pb-1 pt-1 p-1 border-0 rounded mt-2 mb-2">
                          Create Sub KPI
                        </button>
                      </a>
                    )}
                    <table className="w-100 mt-5 m-1 bg-white">
                      <thead className="text-left">
                        <tr className="tableheading">
                          <th>#</th>
                          <th>Sub KPI</th>
                          <th>Description</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Assignees</th>
                          <th>Progress</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPostsSub.map((subgoals, index) => (
                          <tr className="text-left" key={index}>
                            <td>{subgoals.id}</td>
                            <td>{subgoals.title}</td>
                            <td>{subgoals.description}</td>
                            <td>{formatDate(subgoals.startdate)}</td>
                            <td>{formatDate(subgoals.enddate)}</td>
                            <td>{subgoals.assignees}</td>
                            <td hidden>{subgoals.assigneeids}</td>
                            <td>
                              <ProgressBar
                                variant={getProgressColor(subgoals.progress)}
                                now={subgoals.progress}
                              />
                            </td>
                            {/* Action buttons */}
                            <td>
                              {/* <ReactBootstrap.Button className='bg-transparent border-0  col-sm-3' onClick={() => handleComment(smartgoal)}><img src={commentbtn} width="20"></img></ReactBootstrap.Button> */}
                              <ReactBootstrap.Button
                                className="bg-transparent border-0  col-sm-3"
                                onClick={() => handleViewsub(subgoals)}
                              >
                                <img src={viewbtn} width="20"></img>
                              </ReactBootstrap.Button>
                              <ReactBootstrap.Button
                                className="bg-transparent border-0   col-sm-3"
                                onClick={() => handleEditsub(subgoals)}
                              >
                                <img src={Editbtn} width="20"></img>
                              </ReactBootstrap.Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Edit Modal */}
      {showEditModal && editedSmartSubGoal && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit Smart KPI
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>
                <b>Title :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.title}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    title: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Description :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.description}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    description: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Start Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartGoal.startdate}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    startdate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>End Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartGoal.enddate}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    enddate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Progress :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.progress}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    progress: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Assignees :</b>
              </label>
              <input
                type="hidden"
                value={editedSmartGoal.assigneeids}
                onChange={(e) =>
                  editedSmartGoal({
                    ...editedSmartGoal,
                    assignees: e.target.value,
                  })
                }
              />
              <Select
                isMulti={true}
                name="assignees2"
                options={employeesData.map((employee) => ({
                  value: String(employee.employeeid),
                  label: `${employee.FirstName} ${employee.LastName} - ${employee.employeeid}`,
                  // assigneeid: employee.employeeid,
                }))}
                value={selectedAssgneeForEdit}
                onChange={handleSelectChangeForAssignee}
              />
            </div>

            <div>
              {touched.assignees && errors.assignees ? (
                <div className="text-danger">{errors.assignees}</div>
              ) : null}
            </div>
            <input
              type="hidden"
              name="assignees"
              value={(values.assignees = assigneevalues)}
            />

            {/* EDITE */}

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSmartGoal}
            >
              Update
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Comment Modal */}
      <ReactBootstrap.Modal
        show={showCommentModal}
        onHide={handleCloseCommentModal}
      >
        {/* Content of the comment modal */}
      </ReactBootstrap.Modal>

      {/* View Modal */}
      <ReactBootstrap.Modal show={showViewModal} onHide={handleCloseViewModal}>
        {/* Content of the view modal */}
        {viewSmartGoal && (
          <ReactBootstrap.Modal.Dialog className="w-100">
            <ReactBootstrap.Modal.Header closeButton>
              <ReactBootstrap.Modal.Title>Smart KPI</ReactBootstrap.Modal.Title>
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body>
              <p>
                <b>Title:</b> {viewSmartGoal.title}
              </p>
              <p>
                <b>Description:</b> {viewSmartGoal.description}
              </p>
              <p>
                <b>Start Date:</b> {viewSmartGoal.startdate}
              </p>
              <p>
                <b>End Date:</b> {viewSmartGoal.enddate}
              </p>
              <p>
                <b>Designation:</b> {viewSmartGoal.designation}
              </p>
              <p>
                <b>Assignees:</b> {viewSmartGoal.assignees}
              </p>
              <p>
                <b>Progress:</b> {viewSmartGoal.progress}
              </p>
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer>
              <ReactBootstrap.Button
                variant="secondary"
                onClick={handleCloseViewModal}
              >
                Close
              </ReactBootstrap.Button>
              {/* Handle the logic for saving changes here if needed */}
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal.Dialog>
        )}
      </ReactBootstrap.Modal>

      {/* Pagination */}

      <ReactBootstrap.Modal
        show={showViewModalsub}
        onHide={handleCloseViewModalsub}
      >
        {/* Content of the view modal */}
        {viewSubGoal && (
          <ReactBootstrap.Modal.Dialog className="w-100">
            <ReactBootstrap.Modal.Header closeButton>
              <ReactBootstrap.Modal.Title>
                Sub KPI Details
              </ReactBootstrap.Modal.Title>
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body>
              <p>
                <b>Title:</b> {viewSubGoal.title}
              </p>
              <p>
                <b>Description:</b> {viewSubGoal.description}
              </p>
              <p>
                <b>Start Date:</b> {viewSubGoal.startdate}
              </p>
              <p>
                <b>End Date:</b> {viewSubGoal.enddate}
              </p>
              <p>
                <b>Assignees:</b> {viewSubGoal.assignees}
              </p>
              <p>
                <b>Progress:</b> {viewSubGoal.progress}
              </p>
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer>
              <ReactBootstrap.Button
                variant="secondary"
                onClick={handleCloseViewModalsub}
              >
                Close
              </ReactBootstrap.Button>
              {/* Handle the logic for saving changes here if needed */}
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal.Dialog>
        )}
      </ReactBootstrap.Modal>

      {showEditModalsub && editedSmartSubGoal && (
        <ReactBootstrap.Modal
          show={showEditModalsub}
          onHide={handleCloseEditModalsub1}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit Sub KPI
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>
                <b>Title :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartSubGoal.title}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    title: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Description :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartSubGoal.description}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    description: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Start Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartSubGoal.startdate}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    startdate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>End Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartSubGoal.enddate}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    enddate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Progress :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartSubGoal.progress}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    progress: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Assignees :</b>
              </label>
              <input
                type="hidden"
                value={editedSmartSubGoal.assigneeids}
                onChange={(e) =>
                  setEditedSmartSubGoal({
                    ...editedSmartSubGoal,
                    assignees: e.target.value,
                  })
                }
              />
              <Select
                isMulti={true}
                name="assignees2"
                options={employeesData.map((employee) => ({
                  value: employee.id,
                  label: `${employee.FirstName} ${employee.LastName}`,
                }))}
                value={selectedSubgoalEmployees}
                onChange={handleSubgoalChange}
              />
            </div>
            <div>
              {touched.assignees && errors.assignees ? (
                <div className="text-danger">{errors.assignees}</div>
              ) : null}
            </div>
            <input
              type="hidden"
              name="assignees"
              value={(values.assignees = assigneevalues)}
            />
            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSubGoal}
            >
              Update
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModalsub1}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}
      {/* <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.smartgoals.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination> */}

      {/* <ReactBootstrap.Pagination>
        <ReactBootstrap.Pagination.First />
        <ReactBootstrap.Pagination.Prev />
        {Array.from(
          { length: totalPageCount },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
        <ReactBootstrap.Pagination.Next />
        <ReactBootstrap.Pagination.Last />
      </ReactBootstrap.Pagination> */}

      <ReactBootstrap.Pagination>
        <ReactBootstrap.Pagination.First
          onClick={handlePrevGroup}
          disabled={pageGroupStart === 1}
        />
        <ReactBootstrap.Pagination.Prev
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        />

        {currentPageNumbers.map((page) => (
          <ReactBootstrap.Pagination.Item
            key={page}
            active={page === currentPage}
            onClick={() => paginate(page)}
          >
            {page}
          </ReactBootstrap.Pagination.Item>
        ))}

        <ReactBootstrap.Pagination.Next
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPageCount}
        />
        <ReactBootstrap.Pagination.Last
          onClick={handleNextGroup}
          disabled={pageGroupStart + pagesPerGroup > totalPageCount}
        />
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default DataTable;
